
import { Options, Vue } from 'vue-class-component';
import About from '@/components/About.vue'; // @ is an alias to /src
import Logo from "@/base-components/Logo.vue";

@Options({
  components: {
    About,
    Logo
  },
})
export default class AboutUsView extends Vue {}
